'use client';
import React from 'react';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import { CurrentItems } from 'services/fbtItems/types';
import FbtCard from '../fbt-card';
import { ProductsPriceData } from 'app/[lang]/[esite]/(core)/(search-display)/_components/analytics-listener/types';

export interface CurrentItemProps {
  currentItem: CurrentItems;
  partPrice: ProductDealerPriceAvailability & ProductsPriceData;
  currency: string;
  isCatCorp: boolean;
  handleCheckboxChange: (
    e: CustomEvent<{
      checked: boolean;
      indeterminate: boolean;
      value: string;
    }>
  ) => void;
  children: React.ReactNode;
  storeLocationId: string;
  orderItem;
  manufacturerItem: Product;
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
}
const CurrentCard = ({
  currentItem,
  partPrice,
  currency,
  isCatCorp,
  handleCheckboxChange,
  children,
  storeLocationId,
  manufacturerItem,
  orderItem,
  isRTL = false,
  currencyLdFeatureFlag = false
}: CurrentItemProps) => {
  return (
    <FbtCard
      product={currentItem}
      partPrice={partPrice}
      currency={currency}
      isCatCorp={isCatCorp}
      handleCheckboxChange={handleCheckboxChange}
      storeLocationId={storeLocationId}
      manufacturerItem={manufacturerItem}
      orderItem={orderItem}
      isRTL={isRTL}
      currencyLdFeatureFlag={currencyLdFeatureFlag}
    >
      {children}
    </FbtCard>
  );
};

export default CurrentCard;
